/* global ENV */
import get from 'lodash/get';

export default (path) => {
  const val = get(ENV, path);

  if (!val) {
    throw new Error(`${path} does not exist in the config file`);
  }

  return val;
};
